import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components/macro';

export const renderBodyHtml = (value: string) => {
  return <SBodyHtml>{ReactHtmlParser(value)}</SBodyHtml>;
};
const SBodyHtml = styled.div`
  & body {
    position: relative;
  }
`;
